import React, { createContext, useContext, useEffect, useState } from "react";
import { GoogleOAuthProvider } from "@react-oauth/google";
import api from "@/lib/api";

const ConfigContext = createContext({ google_client_id: "", stripe_publishable_key: "", tournament_price_usd: 5 });

export function ConfigProvider({ children }) {
  const [cfg, setCfg] = useState(null);
  useEffect(() => {
    api.get("/config/public").then((r) => setCfg(r.data)).catch(() => setCfg({ google_client_id: "", stripe_publishable_key: "", tournament_price_usd: 5 }));
  }, []);
  if (!cfg) return null;
  const inner = <ConfigContext.Provider value={cfg}>{children}</ConfigContext.Provider>;
  return cfg.google_client_id ? <GoogleOAuthProvider clientId={cfg.google_client_id}>{inner}</GoogleOAuthProvider> : inner;
}

export const useConfig = () => useContext(ConfigContext);
